import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const MerchantsRoutes: Routes = [
  {
    path: "merchants",
    loadComponent: () =>
      import("./merchants/merchants.component").then(
        (m) => m.MerchantsComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./merchants-list/merchants-list.component").then(
            (m) => m.MerchantsListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./merchants-form/merchants-form.component").then(
            (m) => m.MerchantsFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./merchants-form/merchants-form.component").then(
            (m) => m.MerchantsFormComponent,
          ),
      },
      {
        path: "view/:id/affiliate-partner",
        loadComponent: () =>
          import("./affiliate-partner-form/affiliate-partner-form.component").then(
            (m) => m.AffiliatePartnerFormComponent,
          ),
      },
      {
        path: "view/:id/affiliate-partner/:partnerId",
        loadComponent: () =>
          import("./affiliate-partner-form/affiliate-partner-form.component").then(
            (m) => m.AffiliatePartnerFormComponent,
          ),
      },
    ],
  },
];
